import type { ReactNode } from 'react'

/**
 * Page title, the in-context gate line, and the page's primary actions.
 * The description is where each review surface states its gate — "Only
 * approved quotes are retrievable by the agent" (docs/03-page-specs.md §4).
 */
export function PageHeader({
  title,
  description,
  actions,
}: {
  title: string
  description?: ReactNode
  actions?: ReactNode
}) {
  return (
    <header className="mb-4 flex flex-wrap items-start gap-3">
      <div className="min-w-0 flex-1">
        <h1 className="text-[24px] leading-8">{title}</h1>
        {description && (
          <p className="mt-1 max-w-[80ch] text-[13px] leading-5 text-ink-muted">{description}</p>
        )}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </header>
  )
}
